import api from './api';

export async function getEventPromoters(event_id) {
    return api.get(`promoters/event/${event_id}`);
}

export async function getPromoterEvents(id) {
    return api.get(`promoter/${id}/events`);
}

export async function createPromoter(email, nick, event_id, created_by) {
    return api.post(`promoter`, { email, nick, event_id, created_by });
}

export async function getPromoterByUserAndEvent(user_id, event_id) {
    return api.get(`promoter/event/${event_id}/user/${user_id}`);
}

export async function listOrderByPromoterEvent(event_id, refer) {
    return api.get(`/orders/event/${event_id}/promoter/${refer}`);
}

export async function updatePromoter(promoter_id, payload) {
    return api.patch(`promoter/${promoter_id}`, payload);
}

export async function deletePromoter(promoter_id) {
    return api.delete(`promoter/${promoter_id}`);
}

export async function getPromoterDataByEvent(event_id) {
    return api.get(`promoters_data/event/${event_id}`);
}